'use strict';

var enhancedMatcherMethods = require('../var/enhancedMatcherMethods');

var enhancedSome = enhancedMatcherMethods.enhancedSome;

function arrayNone() {
  return !enhancedSome.apply(this, arguments);
}

module.exports = arrayNone;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/enumerable/internal/arrayNone.js
// module id = 1356
// module chunks = 0